import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { SupplierApiKeyService } from '../../supplier-api-key.service';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';

@Component({
  selector: 'vex-supplier-api-key-create',
  templateUrl: './supplier-api-key-create.component.html',
  styleUrls: ['./supplier-api-key-create.component.scss'],
})
export class SupplierApiKeyCreateComponent implements OnInit {
  form: UntypedFormGroup;
  loading = false;
  generatedKey: string | null = null;
  keyCopied = false;
  crudMode = CrudModeEnum.Create;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { supplierId: string },
    public dialogRef: MatDialogRef<SupplierApiKeyCreateComponent>,
    private readonly supplierApiKeyService: SupplierApiKeyService,
    private readonly snackBar: MatSnackBar,
    private readonly clipboard: Clipboard,
  ) {}

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      label: new UntypedFormControl('', [Validators.required]),
    });
  }

  generate(): void {
    if (this.form.invalid) return;
    this.loading = true;

    this.supplierApiKeyService
      .generateApiKeyValue(this.data.supplierId, {
        label: this.form.get('label').value,
      })
      .subscribe({
        next: apiKey => {
          this.generatedKey = apiKey;
          this.loading = false;
          this.dialogRef.disableClose = true;
        },
        error: () => {
          this.snackBar.open('Erreur lors de la génération de la clé', 'Fermer', { duration: 3000 });
          this.loading = false;
        },
      });
  }

  copyKey(): void {
    if (!this.generatedKey) return;
    this.clipboard.copy(this.generatedKey);
    this.keyCopied = true;
    setTimeout(() => (this.keyCopied = false), 2000);
  }

  close(): void {
    this.dialogRef.close(true);
  }
}
